import { render, staticRenderFns } from "./CortinaDimensions.vue?vue&type=template&id=74df4deb&"
import script from "./CortinaDimensions.vue?vue&type=script&lang=js&"
export * from "./CortinaDimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports